import React from 'react';
import { constSelector, useRecoilValue } from 'recoil';
import { blockSubjectInputGroups, customizedBlock, subjectInputGroupSubjects } from 'venn-state';
import { Warning } from 'venn-ui-kit';
import { isFactorTrendMetric } from 'venn-utils';

/** Warning message about factor trend line chart being optimized for only a single investment or portfolio. */
export const FactorTrendLineChartMessage = ({ selectedBlockId }: { selectedBlockId: string }) => {
  const selectedBlock = useRecoilValue(customizedBlock(selectedBlockId));
  const blockSubjectGroups = useRecoilValue(blockSubjectInputGroups(selectedBlockId));

  const firstGroup = blockSubjectGroups[0];
  const firstGroupSubjects = useRecoilValue(firstGroup ? subjectInputGroupSubjects(firstGroup) : constSelector([]));

  const isFactorTrendLineChart =
    selectedBlock.infoGraphicType === 'LINE' && isFactorTrendMetric(selectedBlock.selectedMetrics);
  if (!isFactorTrendLineChart) {
    return null;
  }

  if (blockSubjectGroups.length <= 1 && firstGroupSubjects.length <= 1) {
    return null;
  }

  return <Warning text="For best results select a single factor or a single investment/portfolio." />;
};
